import React from 'react';
import { axius, helper, types } from 'utils';

const StoreSyncLogs = ({ storeCode }) => {
	const [logs, setLogs] = React.useState([]);

	React.useEffect(() => {
		getOmniLogs();
		// const orderTimer = setInterval(() => {
		// 	getData();
		// }, 120 * 1000);
		// return () => {
		// 	clearInterval(orderTimer);
		// };
		// eslint-disable-next-line
	}, []);

	const getOmniLogs = () => {
		axius.get(`stores/${storeCode}/logs`, { job: 'menu' }).then((res) => {
			setLogs(
				[
					res.data.find((l) => l.provider === types.OrdersOrigins.GLOVO),
					res.data.find((l) => l.provider === types.OrdersOrigins.CHOWDECK),
				].filter((l) => l)
			);
		});
	};

	return (
		<React.Fragment>
			<div className={`bg-white px-3 py-2 rounded`}>
				<div className="small text-muted-" style={{ minHeight: 40 }}>
					{logs.length === 0 && <div> No sync logs found</div>}
					{logs.map((log) => (
						<div key={log.id}>
							{log.status ? (
								<i className="fa fa-check-circle text-success" />
							) : (
								<i className="fa fa-times-circle text-danger" />
							)}{' '}
							{types.Providers.find((p) => p.code === log.provider)?.shortLabel}{' '}
							| {helper.format.date(log.createdAt)}
						</div>
					))}
				</div>
			</div>
		</React.Fragment>
	);
};

export default StoreSyncLogs;
